import React from 'react';
import { NavBarHeader } from '../../components/navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FooterWeb } from '../../components/footer';
import { Breadcrumb } from 'react-bootstrap';
import styles from './about.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import styles1 from '../../components/footer/footer.module.css';
import { ScrollToTop } from '../../components/scrolltotop';
const aboutUs = () =>{
    return(<React.Fragment>
        <NavBarHeader></NavBarHeader>
        <section className={styles.breadcrumbs}>
            <div className="container">

                <div className="d-flex justify-content-between align-items-center">
                <h2 style={{ color: "white" }}>About Us</h2>
                    <Breadcrumb>
                        <Breadcrumb.Item href="#">Company</Breadcrumb.Item>
                        <Breadcrumb.Item active>About</Breadcrumb.Item>
                    </Breadcrumb>
                </div>

            </div>
        </section>
        <section>
            <div className="container  mb-4">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className={styles.aboutH3}>Pioneer in Public Safety & Security past 30+ Years</h3>
                        <p className={styles.aboutp}><b>ECIL Rapiscan Ltd. – A Leader in Security Screening Solutions</b></p>
                        <p className={styles.aboutp}>Established in 1995, <b>ECIL Rapiscan Ltd.</b> is a joint venture between <b>OSI Systems, Inc., USA and Electronics Corporation of India Limited (ECIL)</b>, a Government of India enterprise. Since its inception, the company has been a trusted provider of <b>X-ray Baggage Inspection Systems (XBIS),</b> offering both sales and after-sales services.</p>
                        <p className={styles.aboutp}><b>Industry Leadership & Cutting-Edge Technology</b></p>
                        <p className={styles.aboutp}>With over 30 years of experience, ECIL Rapiscan Ltd. has established itself as a leader in the Indian security sector, driven by continuous innovation from Rapiscan Systems, a subsidiary of OSI Systems, Inc. Our solutions help combat terrorism, drug and weapons smuggling, illegal immigration, and trade fraud while ensuring operational efficiency and compliance with stringent security standards.</p>
                        <p className={styles.aboutp}><b>Comprehensive Security Solutions</b></p>
                        <p className={styles.aboutp}>Our expertise spans across:</p>
                        <div className="col-lg-6">
                        <ul className={styles.ulList}>
                        <li> <FontAwesomeIcon icon={faCheck}/> <b>X-Ray Baggage Screening</b> </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>People Screening</b> </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>Radiation & Metal Detection</b> </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>Cargo & Vehicle Inspection</b> </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>Bomb Disposal Solutions</b> </li>                        
                        </ul>
                        </div>
                        <p></p>
                        <p className={styles.aboutp}><b>Global R&D & Advanced Screening Solutions</b></p>
                        <p className={styles.aboutp}>Backed by a <b>state-of-the-art Research & Development facility,</b> Rapiscan Systems continuously innovates software-driven security solutions. The joint venture ensures that Indian customers receive robust and reliable screening systems tailored to their needs.</p>
                        <p className={styles.aboutp}><b>Unmatched Service & Customer Support</b></p>
                        <div className="col-lg-6">
                        <ul className={styles.ulList}>
                        <li> <FontAwesomeIcon icon={faCheck}/> <b>24/7 Customer Care: </b>Dedicated call center for prompt assistance</li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>Nationwide Service Network:</b> 27+ centers across India </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>Rapid Response: </b>Service calls attended within 24 hours </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>Expert Engineers: </b>Highly qualified and trained professionals </li>
                        </ul>
                        </div>
                        <p></p>
                        <p className={styles.aboutp}><b>Certifications & Compliance</b></p>
                        <div className="col-lg-6">
                        <ul className={styles.ulList}>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>ISO 9001:2015 Certified</b> (by TUV) </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>AERB Approved Models</b> (Certified by the Atomic Energy Regulatory Board) </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>BRIT Approved</b> (Ensuring food safety during scanning) </li>
                        <li><FontAwesomeIcon icon={faCheck}/> <b>Spectro Analytical Lab</b> (Ensuring film safety during scanning) </li>
                        </ul>
                        </div>
                        <p></p>
                        <p className={styles.aboutp}><b>Proven Track Record</b></p>
                        <p className={styles.aboutp}>With <b>3,000+</b> satisfied customers and installations across India, <b>ECIL Rapiscan Ltd.</b> remains committed to delivering world-class security solutions that uphold safety and efficiency.</p>
                        <h3 className={styles.sechead}>Our Prestigious Clients include:</h3>
                     
                        </div>
                        <div className="col-lg-6">
                        <ul className={styles.ulList}>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  /> Indian Police & Central Jails
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Defence
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Airforce stations
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />   Airports
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Parliament House
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Public Works Department
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Customs
                  </li>
                  </ul>
                  </div>
                  <div className="col-lg-6">
                  <ul  className={styles.ulList}>
                
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Banking
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Railways
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Temples
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Hotels
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />  Logistics
                  </li>
                  <li>
                  <FontAwesomeIcon icon={faCheck}  />   Corporates and many more
                  </li>
                  </ul>
                  </div>
                  <div className="col-lg-12">
                        <h3 className={styles.aboutH3}>About Rapiscan Systems</h3>
                        <p className={styles.aboutp}><b>Rapiscan Systems,</b> UK & USA (www.rapiscansystems.com) is a subsidiary of OSI Systems Inc., USA. Rapiscan Systems is a leader in manufacturing the latest state-of-the-art XBIS (X-ray and Baggage Screening Solutions) and other related products manufactured to International Standards and approved by the Aviation Authorities in the USA, UK, and EUROPE. Rapiscan has supplied thousands of XBIS to reputed Organizations such as Heathrow Airport, Manchester Airport, Foreign Post Office UK, Her Majesty&apos;s Prisons, Buckingham Palace, and many other USA, Europe, Middle East, South East Asia etc.</p>
                        <h3 className={styles.aboutH3}>About Electronics Corporation of India Limited</h3>
                        <p className={styles.aboutp}><b>Electronics Corporation of India Limited, </b>(www.ecil.co.in) is a wholly-owned Government of India Enterprise and was established in 1967 to create a strong indigenous base in Electronics. ECIL has played a pioneering role in spurring the growth of the electronics industry in India. Over the years, ECIL has evolved into a multi-product, multi-disciplinary organization. The current focus is on increasing contributions to Atomic Energy Sector, Space, Defence Sector, Electronic Security Applications, Communications & Networks, E-Governance Applications and Exports. The company has a man power strength of   1653 employees of which 1050 are executives and 603 are workmen  and a current turnover of around Rs.  1,504 Crore. The Strategic Alliances forged with organizations like Defence Research and Development Organization (DRDO), Bhabha Atomic Research Center (BARC), Nuclear Power Corporation of India Limited (NPCIL), Indira Gandhi Centre for Atomic Research (IGCAR) and Department of Space bear testimony to ECIL&apos;s commitment to the nation.</p>
                </div>
           
                </div>
            </div>
        </section>
        <footer id={styles1.footer}>
        <div className={styles1.footerTop}>
          <div className="container">
            <div className="row">
              <FooterWeb></FooterWeb>
              <div className={styles1.container}>
                <div className={styles1.copyright}>
                  © 2022 <strong><span>ECIL Rapiscan Limited.</span></strong> All Rights Reserved
                </div>

              </div>
            </div>
          </div>
        </div>
      </footer>


      <ScrollToTop></ScrollToTop>
    </React.Fragment>)
} 






export default aboutUs;